import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import {MenuButtonAlignJustify} from 'mui-tiptap';

const StyledEditorMenuButtonAlignJustify = styled(MenuButtonAlignJustify)`
  ${ComponentStyles}
`;

StyledEditorMenuButtonAlignJustify.propTypes = {
  theme: PropTypes.object
};

export default StyledEditorMenuButtonAlignJustify;
